"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSyncedSearch = void 0;
const react_1 = require("react");
const SearchFieldsQueryBuilderPlugin_1 = require("../plugins/SearchFieldsQueryBuilderPlugin");
// update SearchFieldsQueryBuilder plugin params to use the new
// search value and call setQuery to refresh and update the query
function useSyncedSearch(search, query, setQuery) {
    const queryRef = (0, react_1.useRef)(query);
    queryRef.current = query;
    const setQueryRef = (0, react_1.useRef)(setQuery);
    setQueryRef.current = setQuery;
    // when search value changes, set the value to SearchFilters plugin condition params
    (0, react_1.useEffect)(() => {
        var _a, _b;
        const pluginConditions = ((_b = (_a = queryRef.current) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.pluginConditions) || [];
        for (const conditions of pluginConditions) {
            for (const condition of conditions) {
                if (condition.pluginType !== SearchFieldsQueryBuilderPlugin_1.SearchFieldsQueryBuilderPlugin.type ||
                    condition.conditionType !== 'SearchFilter') {
                    continue;
                }
                // set search for condition plugin params
                const params = (condition.params =
                    condition.params || {});
                params.search = search;
            }
        }
        setQueryRef.current(Object.assign({}, queryRef.current));
    }, [search]);
}
exports.useSyncedSearch = useSyncedSearch;
//# sourceMappingURL=useSyncedSearch.js.map